export default {
  type: "array",
  items: {
    type: "object",
    properties: {
      id: {
        type: "integer",
        description: "Measure id",
        example: 5
      },
      priority: {
        type: "integer",
        example: 1
      }
    }
  }
};
